<template>
  <v-container ma-0 pa-0>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-text-field
          v-model="dealerApplication.name"
          :label="$t('message.dealerName')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-text-field
          v-model="dealerApplication.doingBusinessAs"
          :label="$t('message.dba')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-text-field
          v-model="dealerApplication.natureOfBusiness"
          :label="$t('message.typeOfBusiness')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 md4>
        <v-text-field
          v-model="this.orgTypeDisplay()"
          :label="$t('message.organizationType')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 md4>
        <v-text-field
          v-model="dealerApplication.federalTaxIdNumber"
          :label="$t('message.taxID')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 md4 v-if="this.$store.getters.isTDComplete">
        <v-container grid-list-md ma-0 pa-0>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                v-model="dealerApplication.yearsInBusiness"
                :label="$t('message.yearsBusiness')"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="dealerApplication.monthsInBusiness"
                :label="$t('message.monthsBusiness')"
                :disabled="true"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-flex xs8>
        <v-text-field
          v-model="dealerApplication.addressStreet"
          :label="$t('message.dealerAddress')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs4 v-if="this.$store.getters.isGafcoSelected">
        <v-text-field
          v-model="dealerApplication.storeIpAddress"
          :label="$t('message.storeIpAddress')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6>
        <v-text-field
          v-model="dealerApplication.addressCity"
          :label="$t('message.city')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs4 sm2>
        <v-text-field
          v-model="dealerApplication.addressState"
          :label="$t('message.state')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="dealerApplication.addressZipCode"
          :label="$t('message.zipCode')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6>
        <v-text-field
          v-model="dealerApplication.emailAddress"
          :label="$t('message.email')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 sm3>
        <v-text-field
          v-model="dealerApplication.phoneNumber"
          :mask="phoneMask"
          :label="$t('message.businessPhoneNumber')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 sm3>
        <v-text-field
          v-model="dealerApplication.faxNumber"
          :mask="phoneMask"
          :label="$t('message.faxNumber')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs4 v-if="this.$store.getters.isTDComplete">
        <v-currency-field
          v-bind="currencyConfig"
          v-model="dealerApplication.annualSalesAmount"
          :label="$t('message.annualSalesAmount')"
          :disabled="true"
        ></v-currency-field>
      </v-flex>

      <v-flex xs4 v-if="this.$store.getters.isTDComplete">
        <v-currency-field
          v-bind="currencyConfig"
          v-model="dealerApplication.annualFinancingAmount"
          :label="$t('message.annualFinancingAmount')"
          :disabled="true"
        ></v-currency-field>
      </v-flex>

      <v-flex xs4 v-if="!this.$store.getters.isTDRCS">
        <v-currency-field
          v-bind="currencyConfig"
          v-model="dealerApplication.avgTicketAmount"
          :label="$t('message.avgTicketAmount')"
          :disabled="true"
        ></v-currency-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          v-model="dealerApplication.numberOfLocations"
          :label="$t('message.numberOfLocations')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs4 v-if="this.$store.getters.isAvb">
        <v-text-field
          v-model="dealerApplication.avbMarketingId"
          :label="$t('message.avbMarketingId')"
          :disabled="true"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <p>{{ $t('message.questions.website') }}</p>
        <toggle-button
          :sync="true"
          v-model="dealerApplication.website"
          row
          :disabled="true"
          :labels="{ checked: 'Yes', unchecked: 'No' }"
        />
      </v-flex>
      <transition name="slide-fade">
        <v-flex xs12 v-show="dealerApplication.website == true">
          <v-text-field
            v-model="dealerApplication.websiteUrl"
            :label="$t('message.dealerWebsite')"
            :disabled="true"
          ></v-text-field>
        </v-flex>
      </transition>

      <v-flex xs12>
        <p>{{ $t('message.questions.tdMerchantNumber') }}</p>
        <toggle-button
          :sync="true"
          v-model="dealerApplication.activeTdrcsDealer"
          row
          :disabled="true"
          :labels="{ checked: 'Yes', unchecked: 'No' }"
        />
      </v-flex>
      <transition name="slide-fade">
        <v-flex xs12 v-show="dealerApplication.activeTdrcsDealer == true">
          <v-text-field
            v-model="dealerApplication.activeTdrcsDealerNumber"
            :label="$t('message.tdMerchantNumber')"
            :disabled="true"
          ></v-text-field>
        </v-flex>
      </transition>

        <v-flex xs12 v-if="this.$store.getters.isAvb">
          <p>{{ $t('message.questions.avbHostedWebsite') }}</p>
          <toggle-button
            :sync="true"
            v-model="dealerApplication.avbHostedWebsite"
            row
            :disabled="true"
            :labels="{ checked: 'Yes', unchecked: 'No' }"
          />
        </v-flex>

        <v-flex xs12 v-if="this.$store.getters.isAvb">
          <p>{{ $t('message.questions.offerApplyAndBuy') }}</p>
          <toggle-button
            :sync="true"
            v-model="dealerApplication.offerApplyAndBuy"
            row
            :disabled="true"
            :labels="{ checked: 'Yes', unchecked: 'No' }"
          />
        </v-flex>

        <v-flex xs12 v-if="this.$store.getters.isAvb">
          <p>{{ $t('message.questions.wantOnlineCreditAppLink') }}</p>
          <toggle-button
            :sync="true"
            v-model="dealerApplication.wantOnlineCreditAppLink"
            row
            :disabled="true"
            :labels="{ checked: 'Yes', unchecked: 'No' }"
          />
        </v-flex>

    </v-layout>

    <v-layout row wrap
      v-show="programHasReferrers()"
    >
      <v-flex xs12>
        <v-divider style="margin-top: 20px;"></v-divider>
      </v-flex>

      <v-flex xs12 row wrap style="justify-content: center !important;">
        <h3 class="text-xs-center dealer-app-sub">
          {{this.$store.getters.getProgramConfig('referrerLabel') }}
        </h3>

      </v-flex>

      <v-flex xs8 offset-xs2 row wrap style="justify-content: center !important;">
        <p class="text-xs-center subheading">
          {{this.$store.getters.getProgramConfig('referrerLabelHelp') }}
        </p>

      </v-flex>

      <v-flex xs12 row wrap style="justify-content: center !important;">
        <p v-show="!selectedReferrersValid()"
           class="text-xs-center subheading red--text"
        >
          At least one selection is required
        </p>
      </v-flex>

      <v-flex xs12>
        <!-- referrers-->
        <v-layout row wrap class="lender-row">
          <v-flex
            v-for="(referrer,index) in applicationReferrers"
            xs12 :sm6="!singleColReferrers()" :lg3="!singleColReferrers()"
            :key="index"
          >
            <input type="checkbox"
              disabled="disabled"
              v-model="referrer.selected"
            />
            {{ referrer.name }}

            <v-flex xs6 v-show="$store.getters.isUsingDealerNumber && referrer.hasDealerNumber && !!referrer.dealerNumber">
              <v-text-field :key="index" disabled="disabled"
                            v-model="referrer.dealerNumber"
                            maxlength="40"
                            label="Dealer Number"
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-show="this.$store.getters.isTCFRequired">
      <v-flex xs12>
        <v-divider style="margin-top: 20px;"></v-divider>
      </v-flex>

      <v-flex xs12>
        <p class="text-xs-center subheading">
          {{ $t('message.tcf.inventoryFinance') }}
        </p>
      </v-flex>

      <span
        v-html="
          $t('message.tcf.legalText', [
            this.$store.getters.getDealerApplication.name
          ])
        "
      ></span>

      <v-flex xs12 md6>
        <v-text-field
          v-model="dealerApplication.tcfMerchantNumber"
          :label="$t('message.tcf.merchantNumber')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="dealerApplication.tcfAuthorizedSignature"
          :label="$t('message.tcf.authorizedSignature')"
          :disabled="true"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoadingModal from '../util/LoadingModal'
import applicantMixins from '@/mixins/applicantMixins'

export default {
  data: () => ({
    esignature: null,
    esignatureRules: [v => !!v || 'Full Name is required']
  }),
  mixins: [applicantMixins],
  computed: {
    dealerApplication() {
      return this.$store.getters.getDealerApplication
    },
    availableLenders() {
      return this.$store.getters.getAvailableLenders
    },
    applicationReferrers() {
      return this.$store.getters.getDealerApplicationReferrers
    }
  },
  methods: {
    orgTypeDisplay() {
      let orgType = this.$store.getters.getDealerApplication.organizationType
      if (orgType) {
        let message = this.$t('message.orgTypeVals.' + orgType)

        // if the org type is an llc type, smush it in the org type.
        if (this.$store.getters.getDealerApplication.llcType) {
          message += ' (' + this.$t('message.llcTypeVals.' + this.$store.getters.getDealerApplication.llcType) + ' )'
        }
        return message
      } else {
        return ''
      }
    }
  },
  components: {
    'loading-modal': LoadingModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Application/ApplicantView.vue